import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { GlowFadeAnimation } from '../blasts/GlowFade';

registerCollisionAnimation('NEON_PULSE', (ctx, e, config, progress) => {
  GlowFadeAnimation(ctx, e as any, config, progress);
});
